import api from './api';
import type { AiRun, AiRunTool, AiRunsListResponse } from '../types/index';

export interface JobStatusResponse {
  jobId: string;
  runId: string | null;
  status: 'queued' | 'running' | 'done' | 'error';
  stage: string;
  progress: number;
  message: string;
  result: Record<string, unknown> | null;
  hasReport: boolean;
  error: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function listRuns(params?: {
  tool?: AiRunTool;
  page?: number;
  limit?: number;
}): Promise<AiRunsListResponse> {
  const res = await api.get('/ai-runs', { params });
  return res.data.data as AiRunsListResponse;
}

export async function getRun(runId: string): Promise<AiRun> {
  const res = await api.get(`/ai-runs/${runId}`);
  return res.data.data as AiRun;
}

export async function pollJobStatus(jobId: string): Promise<JobStatusResponse> {
  const res = await api.get(`/ai-tools/detector/jobs/${jobId}`);
  return res.data.data as JobStatusResponse;
}
